'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.LogEntry = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _ExceptionParser = require('../ExceptionParser');

var _Exception = require('./Exception');

var _BackgroundException = require('./BackgroundException');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogEntry = exports.LogEntry = function (_Component) {
	_inherits(LogEntry, _Component);

	function LogEntry() {
		_classCallCheck(this, LogEntry);

		var _this = _possibleConstructorReturn(this, (LogEntry.__proto__ || Object.getPrototypeOf(LogEntry)).call(this));

		_this.exceptionParser = new _ExceptionParser.ExceptionParser();
		return _this;
	}

	_createClass(LogEntry, [{
		key: 'render',
		value: function render() {
			if (this.isBackgroundJobException()) {
				return this.renderBackgroundException();
			} else if (this.isException()) {
				return this.renderException();
			} else {
				return this.renderBasic();
			}
		}
	}, {
		key: 'renderBasic',
		value: function renderBasic() {
			return React.createElement(
				'span',
				null,
				this.props.message
			);
		}
	}, {
		key: 'renderException',
		value: function renderException() {
			var exceptionData = this.exceptionParser.parse(this.props.message);
			return React.createElement(_Exception.Exception, exceptionData);
		}
	}, {
		key: 'renderBackgroundException',
		value: function renderBackgroundException() {
			var exceptionData = this.exceptionParser.parse(this.props.message);
			return React.createElement(_BackgroundException.BackgroundException, exceptionData);
		}
	}, {
		key: 'isBackgroundJobException',
		value: function isBackgroundJobException() {
			return this.exceptionParser.isBackgroundJobException(this.props.message);
		}
	}, {
		key: 'isException',
		value: function isException() {
			return this.exceptionParser.isException(this.props.message);
		}
	}]);

	return LogEntry;
}(_react.Component);


//////////////////
// WEBPACK FOOTER
// ./js/Components/LogEntry.js
// module id = 653
// module chunks = 0